import React from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../../assets/images/polar_ace_no_bg.png';
import { ROUTES } from '../../constants';

/**
 * AuthNavbar — Transparent top navbar with Polar Ace logo.
 * Logo click navigates back to the welcome page.
 *
 * @component
 * @returns {JSX.Element}
 */
function AuthNavbar() {
  return (
    <nav className="auth-navbar">
      <Link to={ROUTES.WELCOME} className="auth-navbar__logo-link" aria-label="Go to home page">
        <img src={logoImage} alt="Polar Ace" className="auth-navbar__logo" />
      </Link>
    </nav>
  );
}

export default AuthNavbar;
